import { EventTarget, log, warn } from 'cc';
import { chooseColorByTheme } from '../../../Utils/Utility';

enum EventType {
    Progress = 'Progress',
    Finished = 'Finished',
}

let successIndex: number = 0;
let failedIndex: number = 0;
export default class LoadingTask extends EventTarget {
    public static readonly EVENT_TYPE = EventType;

    private _completeCount: number;
    private _totalCount: number;
    private _isFinished: boolean;
    private _isSuccess: boolean;
    private _error: Error = null;

    constructor(
        private _name: string,
        promise?: Promise<any>,
    ) {
        super();
        log(`%c=== Task: ${_name} Created ===`, `color:${chooseColorByTheme()}`);
        this._completeCount = 0;
        this._totalCount = 0;
        this._isFinished = false;
        this._isSuccess = false;
        if (promise) {
            this._totalCount = 1;
            promise
                .then(() => {
                    this.progress(1, 1);
                    this.finish(null);
                })
                .catch((reason) => {
                    if (reason instanceof Error) {
                        this.finish(reason);
                    } else if (typeof reason === 'string') {
                        this.finish(new Error(reason));
                    } else {
                        this.finish(new Error(`LoadingTask: ${this.name} Failed, reason: ${reason}`));
                    }
                });
        }
    }

    public static get Success(): LoadingTask {
        const task = new LoadingTask(`Success_${successIndex}`);
        task._isFinished = true;
        task._isSuccess = true;
        successIndex++;
        return task;
    }

    public static get Failed(): LoadingTask {
        const task = new LoadingTask(`Failed_${failedIndex}`);
        task._isFinished = true;
        task._isSuccess = true;
        failedIndex++;
        return task;
    }

    public get name() {
        return this._name;
    }

    public get completeCount() {
        return this._completeCount;
    }

    public get totalCount() {
        return this._totalCount;
    }

    public get isFinished() {
        return this._isFinished;
    }

    public get isSuccess() {
        return this._isSuccess;
    }

    public get error() {
        return this._error;
    }

    public waitForFinish() {
        if (this.isFinished) {
            return Promise.resolve();
        }
        return new Promise<void>((resolve) => {
            this.once(EventType.Finished, resolve);
        });
    }

    public waitForStart() {
        if (this.completeCount !== 0) {
            return Promise.resolve();
        }
        return new Promise<void>((resolve) => {
            this.once(EventType.Progress, resolve);
        });
    }

    public progress(completeCount: number, totalCount: number) {
        this._completeCount = completeCount;
        this._totalCount = totalCount;
        // log(`Task: ${this.name}, progrss: ${((this.completeCount / this.totalCount) * 100).toFixed(2)}%`);
        this.emit(EventType.Progress, completeCount / totalCount);
    }

    public finish(err: Error) {
        if (err) {
            warn(err);
        }
        this._error = err;
        this._isSuccess = !err;
        this._isFinished = true;
        log(`%c=== Task: ${this.name} finished (${this.isSuccess ? 'Success' : 'Failed'}) ===`, `color:${chooseColorByTheme()}`);
        this.emit(EventType.Finished);
    }
}
